<template lang="html">
  <div class="splash-screen">
    <div class="full-bg" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        item: []
      },
      cart: {},
      takeaway_detail: {
        take_time: ''
      },
      previousService: '',
      previousStoreId: ''
    }
  },
  mounted() {
    this.setCart()
  },
  methods: {
    async setCart() {
      const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
      if (LOCAL_DATA_CART) {
        this.cart = JSON.parse(LOCAL_DATA_CART)
      }
      const PREVIOUS_SERVICE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type')
      if (PREVIOUS_SERVICE) {
        this.previousService = JSON.parse(PREVIOUS_SERVICE)
      }
      const PREVIOUS_STORE_ID = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')
      if (PREVIOUS_STORE_ID) {
        this.previousStoreId = Number(PREVIOUS_STORE_ID)
      }

      if (!this.$isEmpty(this.$route.params)) {
        if (!this.$isEmpty(this.cart)) {
          if (this.previousService === 'OL-TAKE-AWAY' && this.previousStoreId === Number(this.$route.params.store_id)) {
            this.form = { ...this.cart }
          } else if (this.previousStoreId === Number(this.$route.params.store_id)) {
            this.form.item = this.cart.item
          }
        }

        const obj = {
          url_id: this.$route.params.url_id,
          id: this.$route.params.store_id
        }
        this.$store.dispatch('saveCartV2', this.form)
        this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
        await this.$store.dispatch('fetchOutlet', obj)
        await this.$store.dispatch('saveSelectedId', Number(this.$route.params.store_id))
        this.$router.push({ name: '_menu' }).catch(() => {})
      }
    }
  }
}
</script>
<style>
  .splash-screen, .splash-screen > div, .splash-screen > div > div.full-bg{
    width: 100%;
    height: 100%;
  }
   .full-bg{
    background-color: #1FAD1F;
  }
</style>
